/* eslint-disable */
import { SaveToCache, ReadFromCache, clearCache } from '../Lib/utils.js'

const DefaultChats = { }
export const ChatToState = Chat => {
  console.log(Chat)
  let UnsentMessages = Chat.Unsent.map(pair => pair[1])
  let remoteTimes = Object.keys(Chat.Messages)
    , stateMessages = remoteTimes.map(t => {
      let m = Chat.Messages[t]
        , time = parseFloat(t.slice(1))
      if( typeof m === 'string' ) {
        // let tuple = m.match(/^([^ ]+) ([^ ]+) (.*$)/) // fails with newline \n char, as it does not match the dot.
        let tuple = m.match(/^([^ ]+) ([^ ]+) ([\s\S]*)/)
        return  tuple
                  ? { aTimeStamp : `a${time}`, Time : time, From : tuple[1], FromId : tuple[2], Message : tuple[3] }
                  : { aTimeStamp : 'a0.00000', Time : 0.00000, From : 'Error', FromId : 'Error', Message : 'This message could not be parsed.' }
      }
      else if( typeof m === 'object' ) return Object.assign({ aTimeStamp : `a${time}` }, m)
      else return { aTimeStamp : 'a0.00000', Time : 0.00000, From : 'Error', FromId : 'Error', Message : 'This message could not be parsed.' }
    })
    .concat(UnsentMessages)
    .filter(e => e && e.Time > 0)
    .sort((a,b) => b.Time - a.Time)
    console.tron.display({name: 'ChatToState',preview: "",value: {Chat: Chat, stateMessages: stateMessages, UnsentMessages: UnsentMessages, remoteTimes: remoteTimes}})
    return stateMessages
}
const Filo = (function( ) {
  const load = ( ) => ReadFromCache (filename) .then(data => {
          file = typeof data === 'string'? JSON.parse(data): Object.assign({ }, DefaultChats)
          console.tron.display({name: 'OfflineMsg',preview: "load",value: {file: file}})
        })
      , reset = ( ) => SaveToCache (filename, JSON.stringify(DefaultChats))
      , save = ( ) => SaveToCache (filename, JSON.stringify(file))
      , filo = this
      , DefaultChat = ( ) => ({ ChatId : false, Messages : { }, OtherUnread : { }, Unsent : [ ], Usernames : [ ] })
      , validCacheFile = ( ) => file && typeof file === 'object'
      // , commitChanges = ( ) => save( ).then(load).catch(err => console.warn('critical message cache error: ', err))
      , commitChanges = ( ) => save( ).then(null).catch(err => console.warn('critical message cache error: ', err))
      , validateForWriting = OtherUserId => {
        if( ! validCacheFile( ) ) return Promise.reject('The messaging cache file cannot be parsed.')
        if( ! file[OtherUserId] ) return Promise.reject('There is no such chat.')
        return true
      }
      , reduceHistory = ( messages ) => {
          // Unused at present. File getting too big (approaching a half second to read so far), just keep the most recent 10 items
          timeKeys = Object.keys(messages).reverse().slice(0,10)
          let final = []
          timeKeys.forEach(function(key) {
            final[key] = messages[key]
          })
          return final
      }
  var file = false
    , q = false
    , filename = 'offline-messaging.cache'
    , UID = ''
    , init = UserId => {
        filename = `offline-messaging-${UserId}.cache`
        UID = UserId
        console.tron.log(`OfflineMsg init`)
        return load( ).catch(( ) => reset( ).then(load))
    }
    , startQueue = flushDelay => q? q: setTimeout(( ) => q = false && commitChanges( ), flushDelay)

  return  { init : init
          , clear : ( ) => {
              console.tron.log(`OfflineMsg clearing cache`)
              return reset( ).then(load)
            }
          , get : ( OtherUserId ) => {
                if( ! validCacheFile( ) ) return 'The messaging cache file cannot be parsed.'
                if( ! file[OtherUserId] ) file[OtherUserId] = DefaultChat( )
                console.tron.display({name: 'OfflineMsg',preview: "get (before read)",value: {file_otherUserId: file[OtherUserId]}})
                return Promise.resolve(file[OtherUserId])
            }
          , set : ( OtherUserId, aTimeStampKey, JSONMessage ) => {
                if( ! validCacheFile( ) ) return 'The messaging cache file cannot be parsed.'
                if( ! file[OtherUserId] ) file[OtherUserId] = DefaultChat( )
                console.tron.display({name: 'OfflineMsg',preview: "set",value: {OtherUserId: OtherUserId, aTimeStampKey: aTimeStampKey, JSONMessage: JSONMessage, file_otherUserId: file[OtherUserId]}})
                file[OtherUserId].Unsent.push([aTimeStampKey, JSONMessage])
                console.tron.display({name: 'OfflineMsg',preview: "set2",value: {file_otherUserId: file[OtherUserId]}})
                startQueue(1)
                console.log('offline message set')
                return Promise.resolve(file[OtherUserId])
            }
          , setUsernames : ( OtherUserId, Usernames ) => {
              let reason = validateForWriting ( OtherUserId )
              if( reason !== true ) return reason
              file[OtherUserId].Usernames = Usernames
              // not a queued action, this is blocking.
              return commitChanges( ) // if I didn't already have that in file, it didn't make a difference just now except to the cache.
            }
          , setState : ( OtherUserId, aTimeStampKey, newState ) => {
                let reason = validateForWriting ( OtherUserId )
                if( reason !== true ) return reason
                let next = file[OtherUserId].Unsent.map(m => m[0] === aTimeStampKey? [m[0], Object.assign({ }, m[1], { State : newState })]: m)
                file[OtherUserId].Unsent = next
                console.tron.display({name: 'OfflineMsg',preview: "setState",value: {file_otherUserId: file[OtherUserId]}})
                startQueue(333)
                return Promise.resolve(file[OtherUserId])
            }
          , del : ( OtherUserId, aTimeStampKey ) => {
              let reason = validateForWriting ( OtherUserId )
              if( reason !== true ) return reason
              let spliced = file[OtherUserId].Unsent.filter(u => u[0] !== aTimeStampKey)
              file[OtherUserId].Unsent = spliced
              startQueue(333)
              return Promise.resolve(file[OtherUserId])
            }
          , merge : ( OtherUserId, Chat ) => { // From the API
              Chat.Unsent = [ ]
              if( ! validCacheFile( ) ) return Promise.reject('Cache file could not be established.')
              console.tron.display({name: 'OfflineMsg',preview: "merge",value: {OtherUserId: OtherUserId, Chat: Chat, file: file}})
              if( ! file[OtherUserId] ) {
                file[OtherUserId] = Chat
                startQueue(333)
                return Promise.resolve(Chat)
              }
              if ( file[OtherUserId].ChatId === false ) {
                file[OtherUserId].ChatId = Chat.ChatId
              }
              if( file[OtherUserId].ChatId !== Chat.ChatId ) {
                  console.tron.log(`Error: chatId has changed, writing`)
                  file[OtherUserId] = Chat
                  console.tron.display({name: 'OfflineMsg',preview: "merge2",value: {file_otherUserId: file[OtherUserId]}})
                  startQueue(333)
                  return Promise.resolve(Chat)
              } else {
                let cache = file[OtherUserId].Messages
                  , remoteTimes = Object.keys(Chat.Messages)
                  , repl = remoteTimes.reduce((li,u) => {
                      li[u] = Chat.Messages[u]
                      return li
                  }, cache)
                  file[OtherUserId].Messages = Chat.Messages
                  file[OtherUserId].OtherUnread = Chat.OtherUnread
                  console.tron.display({name: 'OfflineMsg',preview: "merge3",value: {file_otherUserId: file[OtherUserId], remoteTimes: remoteTimes, cache: cache}})
                  startQueue(333)
                  return Promise.resolve(file[OtherUserId])
              }
            }
          , setChatId : (OtherUserId, ChatId) => {
              const reason = validateForWriting( OtherUserId )
              if ( reason != true) return reason
              if (typeof file[OtherUserId].ChatId == 'undefined' || !file[OtherUserId].ChatId) {
                file[OtherUserId].ChatId = ChatId
                console.tron.display({name: 'OfflineMsg',preview: "setChatId",value: {OtherUserId: OtherUserId, ChatId: ChatId, file_otherUserId: file[OtherUserId]}})
                startQueue(333)
                return Promise.resolve(file[OtherUserId])
              }
              else
                console.tron.display({name: 'OfflineMsg',preview: "setChatId2",value: {OtherUserId: OtherUserId, ChatId: ChatId, file_otherUserId: file[OtherUserId]}})
            }
          , chatSuccess : Message => {
              let OtherUserId = Message.ToId === UID? Message.FromId: Message.ToId
                , reason = validateForWriting ( OtherUserId )
              if( reason !== true ) return reason
              file[OtherUserId].Messages[`a${Message.Time}`] = Message
              let nextUnsent = file[OtherUserId].Unsent.filter(pair => pair[1].Message !== Message.Message)
              file[OtherUserId].Unsent = nextUnsent
              if (typeof Message.ChatId != 'undefined')
                file[OtherUserId].ChatId = Message.ChatId
              console.tron.display({name: 'OfflineMsg',preview: "chatSuccess",value: {Message: Message, file_otherUserId: file[OtherUserId]}})
              startQueue(333)
              console.log('chat success, message: ', JSON.stringify(Message))
              return Promise.resolve(file[OtherUserId])
            }
          , chatDelete : Message => {
              let reason = validateForWriting ( Message.OtherUserId )
              if( reason !== true ) return reason
              delete file[Message.OtherUserId].Messages[Message.aTimeStamp]
              startQueue(333)
              console.log('chat delete: ', JSON.stringify(file[Message.OtherUserId]))
              return Promise.resolve(file[Message.OtherUserId])
          }
          , remove : OtherUserId => {
              let reason = validateForWriting ( OtherUserId )
              if( reason !== true ) return reason
              delete file[OtherUserId]
              startQueue(333)
              return Promise.resolve('There is no data')
            }
          }
})( )

export const OfflineMessaging = Filo
